import Route from '@ember/routing/route';

export default class LibraryFoldersIndexRoute extends Route {
  queryParams = {
    parent: {
      refreshModel: true,
    },
  };

  model(params: { parent?: string }) {
    return {
      path: params.parent || '|',
    };
  }
}
